import React from 'react';
import { useBattle } from '../context/BattleProvider';
import { useLiveKitRoom } from '../hooks/useLiveKitRoom';
import { ParticipantTile } from '../components/ParticipantTile';
import { BattleChat } from '../components/BattleChat';

// Viewers: subscribe-only. See the pinned spotlight + all participants, live chat.
export const ViewerView: React.FC = () => {
  const { session, livekitToken, livekitUrl } = useBattle();

  const { isConnected, remoteParticipants } = useLiveKitRoom({
    url: livekitUrl,
    token: livekitToken,
  });

  const pinnedParticipant = remoteParticipants.find(
    (p) => p.identity === session?.pinned_participant
  );

  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: '1fr 280px',
        gap: 16,
        height: 'calc(100vh - 60px)',
        padding: 20,
        boxSizing: 'border-box',
      }}
    >
      {/* ── LEFT: stage ── */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: 12, minHeight: 0 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <h2 style={{ fontFamily: 'var(--font-display)', fontSize: '1.3rem', fontWeight: 800 }}>
            {session?.title}
          </h2>
          {session?.status === 'live' ? (
            <span
              className="pill"
              style={{ background: 'rgba(74,222,128,0.15)', color: '#4ade80' }}
            >
              LIVE
            </span>
          ) : (
            <span className="pill">Waiting to start</span>
          )}
          <span style={{ marginLeft: 'auto', fontSize: 12, color: 'var(--text-muted)' }}>
            {isConnected ? 'Watching' : 'Connecting…'}
          </span>
        </div>

        {/* Main spotlight */}
        <div
          style={{
            background: '#000',
            borderRadius: 'var(--radius-lg)',
            border: '2px solid var(--accent)',
            overflow: 'hidden',
            aspectRatio: '16/9',
          }}
        >
          {pinnedParticipant ? (
            <ParticipantTile
              participant={pinnedParticipant}
              isPinned
              isHost={false}
              onPin={() => {}}
            />
          ) : (
            <div
              style={{
                height: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: 'var(--text-muted)',
                fontSize: 14,
              }}
            >
              Waiting for battle to begin…
            </div>
          )}
        </div>

        {/* Other participants in a smaller row */}
        {remoteParticipants.filter((p) => p.identity !== session?.pinned_participant).length >
          0 && (
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fill, minmax(160px, 1fr))',
              gap: 8,
            }}
          >
            {remoteParticipants
              .filter((p) => p.identity !== session?.pinned_participant)
              .map((p) => (
                <ParticipantTile
                  key={p.identity}
                  participant={p}
                  isPinned={false}
                  isHost={false}
                  onPin={() => {}}
                />
              ))}
          </div>
        )}
      </div>

      {/* ── RIGHT: chat ── */}
      <div
        style={{
          background: 'var(--bg-surface)',
          border: '1px solid var(--border)',
          borderRadius: 'var(--radius-lg)',
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          minHeight: 0,
        }}
      >
        <BattleChat />
      </div>
    </div>
  );
};
